import validate from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}